import type { AttachmentMediaPresenceUpdate } from '@blocksuite/affine/blocks/attachment';
import { useMemo } from 'react';

import { AudioBlockEmbedded } from './audio/audio-block';
import { AttachmentPreviewErrorBoundary } from './error';
import { PDFViewerEmbedded } from './pdf/pdf-viewer-embedded';
import type { AttachmentViewerProps } from './types';
import { getAttachmentType } from './utils';

type AttachmentEmbedPreviewProps = AttachmentViewerProps & {
  publishMediaPresence?: (update: AttachmentMediaPresenceUpdate) => void;
};

// Embed view
export const AttachmentEmbedPreview = ({
  model,
  publishMediaPresence,
}: AttachmentEmbedPreviewProps) => {
  const attachmentType = getAttachmentType(model);
  const element = useMemo(() => {
    switch (attachmentType) {
      case 'pdf':
        return <PDFViewerEmbedded model={model} />;
      case 'audio':
        return (
          <AudioBlockEmbedded
            model={model}
            publishMediaPresence={publishMediaPresence}
          />
        );
      default:
        return null;
    }
  }, [attachmentType, model, publishMediaPresence]);
  return (
    <AttachmentPreviewErrorBoundary>{element}</AttachmentPreviewErrorBoundary>
  );
};
